import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useFormatMessage } from 'app/common/hooks';

import messages from './CallForPricing.messages';

/**
 * Shown in place of a price when a product has no price.
 */
const CallForPricing = ({ className }) => {
  const formatMessage = useFormatMessage();

  return (
    <span className={cx('CallForPricing', className)}>
      {formatMessage(messages.label)}
    </span>
  );
};

CallForPricing.propTypes = {
  className: PropTypes.string
};

export default CallForPricing;
export { CallForPricing };
